/* global axios */
import ApiClient from './ApiClient';

const positiveIntegerPathSegment = (value, name) => {
  const normalizedValue = String(value ?? '').trim();
  if (!/^[1-9]\d*$/.test(normalizedValue)) {
    throw new TypeError(`${name} must be a positive integer`);
  }
  return encodeURIComponent(normalizedValue);
};

// FR2 — Multiple contacts/conversations per Pipeline card. These joins are
// purely additive: the primary link stays pipeline_cards.contact_id /
// conversation_display_id (retrocompat with automations/webhooks/n8n/MCP/
// customer API). Backend: Api::V1::Accounts::Pipeline::CardContactsController
// / CardConversationsController.
//
// The routes live under /pipeline/cards/:card_id/(contacts|conversations),
// not /pipeline_cards/:id — mirrors the remap already done in leadScores.js.
class PipelineCardLinksAPI extends ApiClient {
  constructor() {
    super('pipeline_cards', { accountScoped: true });
  }

  linksBaseUrl(accountId = null) {
    if (accountId === null || accountId === undefined) {
      return this.url.replace('/pipeline_cards', '/pipeline/cards');
    }
    return `/api/v1/accounts/${positiveIntegerPathSegment(
      accountId,
      'accountId'
    )}/pipeline/cards`;
  }

  addContact(cardId, contactId, role = null, { accountId = null } = {}) {
    const baseUrl = this.linksBaseUrl(accountId);
    const payload = { contact_id: contactId };
    if (role) payload.role = role;
    return axios.post(
      `${baseUrl}/${positiveIntegerPathSegment(cardId, 'cardId')}/contacts`,
      payload
    );
  }

  removeContact(cardId, joinId, { accountId = null } = {}) {
    const baseUrl = this.linksBaseUrl(accountId);
    return axios.delete(
      `${baseUrl}/${positiveIntegerPathSegment(
        cardId,
        'cardId'
      )}/contacts/${positiveIntegerPathSegment(joinId, 'joinId')}`
    );
  }

  addConversation(cardId, conversationDisplayId, { accountId = null } = {}) {
    const baseUrl = this.linksBaseUrl(accountId);
    return axios.post(
      `${baseUrl}/${positiveIntegerPathSegment(
        cardId,
        'cardId'
      )}/conversations`,
      { conversation_display_id: conversationDisplayId }
    );
  }

  removeConversation(cardId, joinId, { accountId = null } = {}) {
    const baseUrl = this.linksBaseUrl(accountId);
    return axios.delete(
      `${baseUrl}/${positiveIntegerPathSegment(
        cardId,
        'cardId'
      )}/conversations/${positiveIntegerPathSegment(joinId, 'joinId')}`
    );
  }
}

export default new PipelineCardLinksAPI();
